import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  days: 'Día 1 al 7',
  title: 'Auditoría Quirúrgica',
  description: 'Realizarás una auditoría quirúrgica de tus movimientos bancarios para detener las fugas de dinero inmediatas.'
}, {
  days: 'Día 8 al 15',
  title: "Configurar tus '3 Cubetas'",
  description: "Configurarás tus '3 Cubetas' de flujo de caja para automatizar tus ahorros y tus gastos fijos."
}, {
  days: 'Día 16 al 23',
  title: 'Priorización de Deudas',
  description: 'Aplicarás el sistema de priorización de deudas para eliminar intereses innecesarios.'
}, {
  days: 'Día 24 al 30',
  title: 'El Hábito de 5 Minutos',
  description: 'Establecerás el hábito de revisión de 5 minutos para que el sistema funcione solo, mes tras mes.'
}];
export function RoadmapSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-brand-dark" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <div className="text-center mb-16" data-id="element-109">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-serif font-bold text-white mb-6" data-id="element-110">
            TU TRANSFORMACIÓN EN 30 DÍAS
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-300 text-lg max-w-2xl mx-auto" data-id="element-111">
            Este no es un libro de teoría, es un{' '}
            <strong className="text-white" data-id="element-112">plan de ejecución táctica</strong>:
          </motion.p>
        </div>

        <div className="relative" data-id="element-113">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-slate-800 md:-translate-x-1/2" data-id="element-114" />

          <div className="space-y-12" data-id="element-115">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            delay: index * 0.15
          }} className={`relative flex flex-col md:flex-row gap-8 md:gap-0 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-116">
                {/* Timeline Dot */}
                <div className="absolute left-4 md:left-1/2 w-4 h-4 rounded-full bg-brand-accent border-4 border-brand-dark md:-translate-x-1/2 mt-1.5 md:mt-0 z-10" data-id="element-117" />

                {/* Content */}
                <div className={`ml-12 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:pl-12' : 'md:pr-12 text-left md:text-right'}`} data-id="element-118">
                  <div className="bg-brand-card p-6 rounded-2xl border border-slate-800 hover:border-brand-accent/30 transition-colors" data-id="element-119">
                    <span className="inline-block px-3 py-1 bg-brand-accent/10 text-brand-accent text-sm font-bold rounded-full mb-4" data-id="element-120">
                      {step.days}
                    </span>
                    <h3 className="text-xl font-bold text-white mb-2 font-serif" data-id="element-121">
                      {step.title}
                    </h3>
                    <p className="text-slate-400 leading-relaxed" data-id="element-122">
                      {step.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}